// 生产流程修改后版本
<!-- 设备管理-生产列表 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea ProductList">
    <!-- 主要头部内容 -->
    <div class="mainHeadContent">
      <!-- 面包屑 -->
      <BreadCrumb></BreadCrumb>
    </div>
    <!--主内容区-->
    <div class="mainBodyContent">
      <!-- 生产列表 -->
      <el-tabs v-model="activeTab">
        <!-- 未入库 -->
        <el-tab-pane
          label="未入库"
          name="noStorage"
          class="noStorage"
          v-if="1 || tab.noStorage"
        >
          <!-- 查询框 -->
          <div class="queryBox clearfix">
            <el-input
              class="dateInput"
              placeholder="请输入设备ID"
              v-model="noStorageData.device_id"
              clearable
            ></el-input>
            <el-input
              class="dateInput"
              placeholder="请输入备注内容"
              v-model="noStorageData.contents"
              clearable
            ></el-input>
            <el-date-picker
              class="dateInput"
              v-model="noStorageData.dateRange"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            <el-button
              class="queryBtn"
              type="primary"
              @click="getDeviceNoList('query')"
              >查 询</el-button
            >
          </div>
          <!-- 按钮区域 -->
          <div class="btnArea btnDiv">
            <div>
              <el-button @click="operateDialogInfo('batchStorage')"
                >批量入库</el-button
              >
              <el-button @click="operateDialogInfo('batchDelete')"
                >批量删除</el-button
              >
              <el-button @click="operateDialogInfo('batchPrint')"
                >批量打印</el-button
              >
              <!-- <el-checkbox v-model="noStorageData.status" class="ml20" @change="getDeviceNoList('query')">显示已使用的设备ID</el-checkbox> -->
            </div>
            <div>
              <el-button @click="operateDialogInfo('customGenerateId')"
                >手动添加ID</el-button
              >
              <el-button @click="operateDialogInfo('generateId')"
                >生成ID</el-button
              >
              <el-button @click="viewLog">查看日志</el-button>
            </div>
          </div>
          <!-- 未入库列表 -->
          <el-table
            ref="noStorage"
            v-loading="noStorageData.loading"
            :data="noStorageData.list"
            @selection-change="noStorageSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="device_no_id" label="设备ID" sortable>
            </el-table-column>
            <el-table-column label="二维码">
              <template slot-scope="scope">
                <el-button
                  class="text"
                  type="text"
                  @click="operateDialogInfo('viewQrcode', scope.row)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="来源">
              <template slot-scope="scope">
                <span>{{ sourceList[scope.row.source] }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="statusName"
              label="状态">
            </el-table-column> -->
            <el-table-column
              prop="create_time"
              label="添加时间"
              sortable
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column label="备注" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{
                  scope.row.contents === "" ? "/" : scope.row.contents
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" class-name="operate">
              <template slot-scope="scope">
                <el-button
                  class="text"
                  type="text"
                  @click="operateDialogInfo('audit', scope.row)"
                  v-if="scope.row.source === '2'"
                  >审核</el-button
                >
                <el-button
                  class="text"
                  type="text"
                  @click="operateDialogInfo('storage', scope.row)"
                  v-else
                  >入库</el-button
                >
                <el-button
                  class="text"
                  type="text"
                  @click="operateDialogInfo('delete', scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="paging" v-if="1 || noStorageData.pageCount > 1">
            <el-pagination
              @current-change="noStoragePageChange"
              :current-page.sync="noStorageData.paging.page"
              layout="total, sizes,prev, pager, next, jumper"
              :page-sizes="pageSizes"
              :page-size.sync="noStorageData.paging.perPage"
              @size-change="handleSizeChange"
              :page-count="noStorageData.pageCount"
              :total="noStorageData.total"
            >
            </el-pagination>
          </div>
        </el-tab-pane>

        <!-- 已入库 -->
        <el-tab-pane
          label="已入库"
          name="hasStorage"
          v-if="1 || tab.hasInStock"
        >
          <!-- 查询框 -->
          <div class="queryBox clearfix">
            <el-input
              class="dateInput"
              v-model="hasStorageData.paging.device_no_id"
              placeholder="请输入设备ID"
              clearable
            ></el-input>
            <el-button
              class="queryBtn"
              type="primary"
              @click="getInStockList('query')"
              >查 询</el-button
            >
          </div>
          <!-- 按钮区域 -->
          <div class="btnArea clearfix">
            <el-tooltip
              effect="dark"
              content="第三方设备禁止与其他设备批量出库"
              placement="top"
            >
              <el-button class="batchOutputBtn" @click="output('batchOutput')"
                >批量出库</el-button
              >
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="第三方设备禁止回收"
              placement="top"
            >
              <el-button
                class="batchRecycleBtn"
                @click="operateDialogInfo('batchRecycle')"
                >批量回收</el-button
              >
            </el-tooltip>
            <el-button @click="operateDialogInfo('batchPrint')"
              >批量打印</el-button
            >
            <el-button class="viewLogBtn" @click="viewLog">查看日志</el-button>
          </div>

          <!-- 已入库列表 -->
          <el-table
            ref="hasStorage"
            v-loading="hasStorageData.loading"
            :data="hasStorageData.list"
            style="width: 100%"
            @selection-change="hasStorageSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="device_no_id" label="设备ID">
            </el-table-column>
            <el-table-column
              prop="board_type_name"
              label="主板类型"
              width="200"
            >
            </el-table-column>
            <el-table-column label="固件版本">
              <template slot-scope="scope">
                <span>{{
                  scope.row.firmware_version === ""
                    ? "/"
                    : scope.row.firmware_version
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="mac_address" label="mac地址">
            </el-table-column>
            <el-table-column label="来源">
              <template slot-scope="scope">
                <span>{{ sourceList[scope.row.source] }}</span>
              </template>
            </el-table-column>
            <el-table-column label="二维码">
              <template slot-scope="scope">
                <el-button
                  class="text"
                  type="text"
                  @click="operateDialogInfo('viewQrcode', scope.row)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
            <el-table-column prop="in_stock_time" label="入库时间">
            </el-table-column>
            <el-table-column label="备注" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{
                  scope.row.contents === "" ? "/" : scope.row.contents
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" class-name="operate">
              <template slot-scope="scope">
                <el-button
                  class="text"
                  type="text"
                  @click="output('output', scope.row)"
                  >出库</el-button
                >
                <el-button
                  class="text"
                  type="text"
                  @click="operateDialogInfo('recycle', scope.row)"
                  :disabled="scope.row.device_id !== '0'"
                  >回收</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="paging" v-if="1 || hasStorageData.pageCount > 1">
            <el-pagination
              @current-change="hasStoragePageChange"
              :current-page.sync="hasStorageData.paging.page"
              @size-change="hasStorageSizeChange"
              :page-sizes="pageSizes"
              :page-size.sync="hasStorageData.paging.perPage"
              :page-count="hasStorageData.pageCount"
              :total="hasStorageData.paging.total"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </el-tab-pane>

        <!-- 已出库 -->
        <el-tab-pane
          label="已出库"
          name="hasOutput"
          v-if="1 || tab.hasOutStock"
        >
          <!-- 查询框 -->
          <div class="queryBox clearfix">
            <el-input
              class="dateInput"
              v-model="hasOutputData.paging.device_no_id"
              placeholder="请输入设备ID"
              clearable
            ></el-input>
            <el-input
              class="dateInput"
              v-model="hasOutputData.paging.company_name"
              placeholder="请输入所属公司"
              clearable
            ></el-input>

            <el-select
              class="dateInput"
              placeholder="请选择用途"
              v-model="hasOutputData.paging.device_id"
              @change="getOutStockList('query')"
              clearable
            >
              <el-option-group
                v-for="group in deviceList"
                :key="group.device_id"
                :label="group.name"
              >
                <el-option
                  v-for="item in group.children"
                  :key="item.device_id"
                  :label="item.name"
                  :value="item.device_id"
                >
                </el-option>
              </el-option-group>
            </el-select>

            <el-select
              class="dateInput"
              placeholder="请选择设备状态"
              v-model="hasOutputData.paging.online_status"
              @change="getOutStockList('query')"
              clearable
            >
              <el-option
                v-for="item in onlineStatusOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>

            <el-button
              class="queryBtn"
              type="primary"
              @click="getOutStockList('query')"
              >查 询</el-button
            >
          </div>
          <!-- 按钮区域 -->
          <div class="btnArea clearfix">
            <el-button
              class="batchRecycleBtn"
              @click="operateDialogInfo('hasOutputBatchEdit')"
              >批量修改</el-button
            >
            <el-tooltip
              effect="dark"
              content="已激活设备、第三方设备禁止回收"
              placement="top"
            >
              <el-button
                class="batchRecycleBtn"
                @click="operateDialogInfo('hasOutputBatchRecycle')"
                >批量回收</el-button
              >
            </el-tooltip>
            <el-button @click="operateDialogInfo('batchPrint')"
              >批量打印</el-button
            >
            <el-button class="viewLogBtn" @click="viewLog">查看日志</el-button>
          </div>

          <!-- 已出库列表 -->
          <el-table
            ref="hasOutput"
            v-loading="hasOutputData.loading"
            :data="hasOutputData.list"
            @selection-change="hasOutputSelectionChange"
            @sort-change="handleSortChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="device_no_id" label="设备ID">
            </el-table-column>
            <el-table-column prop="card_no" label="其他平台设备ID">
            </el-table-column>
            <el-table-column prop="board_ip" label="局域网ip">
            </el-table-column>
            <el-table-column
              prop="server_category_name"
              label="服务器组"
              width="100"
            >
            </el-table-column>
            <el-table-column prop="company_name" label="代理商名称">
            </el-table-column>
            <el-table-column prop="device_name" label="设备类型">
            </el-table-column>
            <el-table-column prop="brand_name" label="设备品牌">
            </el-table-column>
            

            <!-- <el-table-column
              prop="is_activation_text"
              label="激活状态"
              width="90px"
            >
              <template slot-scope="scope">
                <span
                  :style="{
                    color:
                      scope.row.is_activation === '0' ? '#ff0000' : '#008000'
                  }"
                  >{{ scope.row.is_activation_text }}</span
                >
              </template>
            </el-table-column> -->

            <el-table-column label="设备状态" width="100px" 
            sortable="custom"
            prop="online"
            >
              <template slot-scope="scope">
                <span
                  :style="{ color: scope.row.online ? '#008000' : '#ff0000' }"
                  >{{ scope.row.online_name }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="二维码">
              <template slot-scope="scope">
                <el-button
                  class="text"
                  type="text"
                  @click="operateDialogInfo('viewQrcode', scope.row)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
            <el-table-column prop="out_stock_time" label="出库时间" sortable="custom">
            </el-table-column>
            <el-table-column label="操作" class-name="operate">
              <template slot-scope="scope">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <!-- <el-dropdown-item :disabled="!scope.row.online" @click.native="configMainboard(scope.row)">配置主板</el-dropdown-item>
                    <el-dropdown-item @click.native="operateDialogInfo('configCom', scope.row)">配置通讯</el-dropdown-item> -->
                    <el-dropdown-item
                      @click.native="
                        operateDialogInfo('editOutputDetail', scope.row)
                      "
                      >修改</el-dropdown-item
                    >
                    <el-dropdown-item
                      @click.native="
                        operateDialogInfo('hasOutputDetail', scope.row)
                      "
                      >详情</el-dropdown-item
                    >
                    <el-dropdown-item
                      @click.native="
                        operateDialogInfo('hasOutputRecycle', scope.row)
                      "
                      :disabled="
                        scope.row.is_activation === '1' ||
                          scope.row.source === '3'
                      "
                      >回收</el-dropdown-item
                    >
                    <el-dropdown-item
                      @click.native="boxConfig(scope.row)"
                      v-if="scope.row.device_type === '1'"
                      >配置信息</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="paging">
            <el-pagination
              @current-change="hasOutputPageChange"
              :current-page.sync="hasOutputData.paging.page"
              @size-change="hasOutputSizeChange"
              :page-sizes="pageSizes"
              :page-size.sync="hasOutputData.paging.perPage"
              :page-count="hasOutputData.pageCount"
              :total="hasOutputData.total"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>

      <!--对话框-->
      <el-dialog
        :width="dialogData.type === 'viewQrcode' ? '300px' : '650px'"
        :title="dialogData.title"
        :visible.sync="dialogData.visible"
        :show-close="dialogData.title === '' ? false : true"
      >
        <!-- 未入库按钮操作 -->
        <!-- 入库/批量入库 -->
        <div
          v-if="
            dialogData.type === 'storage' || dialogData.type === 'batchStorage'
          "
        >
          <el-form
            ref="storageForm"
            label-width="100px"
            :model="dialogData.info"
          >
            <el-form-item
              label="主板类型:"
              prop="board_type"
              :rules="[
                { required: true, message: '请选择主板类型', trigger: 'blur' }
              ]"
            >
              <div class="inputBox">
                <el-select
                  class="inputDeposit"
                  placeholder="请选择主板类型"
                  v-model="dialogData.info.board_type"
                  clearable
                >
                  <el-option
                    :label="item"
                    :value="index"
                    v-for="(item, index) in boardTypeList"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="固件版本:" prop="firmware_version">
              <div class="inputBox">
                <el-input
                  class="inputDeposit"
                  v-model="dialogData.info.firmware_version"
                  clearable
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="mac地址:" prop="mac_address">
              <div class="inputBox">
                <el-input
                  class="inputDeposit"
                  v-model="dialogData.info.mac_address"
                  clearable
                ></el-input>
              </div>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="inStock">确 认</el-button>
          </div>
        </div>

        <!-- 审核 -->
        <div v-if="dialogData.type === 'audit'">
          <el-form label-width="100px" :model="dialogData.info">
            <el-form-item label="主板类型:">
              <div class="inputBox">
                {{ boardTypeList[dialogData.info.board_type] }}
              </div>
            </el-form-item>
            <el-form-item label="固件版本:">
              <div class="inputBox">{{ dialogData.info.firmware_version }}</div>
            </el-form-item>
            <el-form-item label="mac地址:">
              <div class="inputBox">{{ dialogData.info.mac_address }}</div>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="verifyInStock">通 过</el-button>
          </div>
        </div>

        <!-- 生成设备id -->
        <div v-else-if="dialogData.type === 'generateId'">
          <el-form label-width="120px" :model="dialogData.info">
            <el-form-item label="生成类型:">
              <div class="inputBox">
                <el-select
                  class="inputDeposit"
                  placeholder="请选择生成类型"
                  v-model="dialogData.info.length"
                >
                  <el-option label="6位" value="6"></el-option>
                  <el-option label="11位" value="11"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="要生成ID数量:">
              <div class="inputBox">
                <el-input
                  class="inputDeposit"
                  v-model="dialogData.info.number"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="备注:">
              <el-input
                class="inputDeposit"
                type="textarea"
                rows="4"
                v-model="dialogData.info.contents"
              ></el-input>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="generateId()">确 认</el-button>
          </div>
        </div>

        <!-- 手动添加设备ID -->
        <div v-else-if="dialogData.type === 'customGenerateId'">
          <el-form label-width="80px" :model="dialogData.info">
            <el-form-item label="设备ID:">
              <div class="inputBox">
                <el-input
                  class="inputDeposit"
                  v-model="dialogData.info.device_no_id"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="备注:">
              <el-input
                class="inputDeposit"
                type="textarea"
                rows="4"
                v-model="dialogData.info.contents"
              ></el-input>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="customGenerateId()"
              >确 认</el-button
            >
          </div>
        </div>

        <!-- 删除 -->
        <div
          class="changeStatusWrapper"
          v-else-if="
            dialogData.type === 'delete' || dialogData.type === 'batchDelete'
          "
        >
          <!-- 批量删除 -->
          <p class="text">
            确认
            <span class="bold">{{
              dialogData.type === "delete" ? "删除" : "批量删除"
            }}</span>
            所选设备？
          </p>

          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogData.visible = false">取消</el-button>
            <!-- 删除id -->
            <el-button @click="deleteId()">确认</el-button>
          </div>
        </div>

        <!-- 已入库/已出库（hasOutput）回收 -->
        <div
          class="changeStatusWrapper"
          v-else-if="
            dialogData.type === 'recycle' ||
              dialogData.type === 'batchRecycle' ||
              dialogData.type === 'hasOutputRecycle' ||
              dialogData.type === 'hasOutputBatchRecycle'
          "
        >
          <!-- 批量回收 -->
          <p class="text">
            确认
            <span class="bold">{{
              dialogData.type === "recycle" ||
              dialogData.type === "hasOutputRecycle"
                ? "回收"
                : "批量回收"
            }}</span>
            所选
            {{
              dialogData.type === "recycle" ||
              dialogData.type === "batchRecycle"
                ? "已入库"
                : "已出库"
            }}
            设备？
          </p>

          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogData.visible = false">否</el-button>
            <!-- 确认回收 -->
            <!-- 已入库回收 -->
            <el-button
              @click="inStockRecycle()"
              v-if="
                dialogData.type === 'recycle' ||
                  dialogData.type === 'batchRecycle'
              "
              >是</el-button
            >
            <!-- 已出库回收 -->
            <el-button @click="outStockRecycle()" v-else>是</el-button>
          </div>
        </div>

        <!-- 打印单个-查看二维码 -->
        <div class="qrcodeBox" v-else-if="dialogData.type === 'viewQrcode'">
          <div class="btnBox">
            <!-- <el-button v-print="'#singleQrcodeBox'">打印</el-button> -->
            <el-button @click="singlePrint">打印</el-button>
          </div>
          <div id="singleQrcodeBox" ref="singleQrcodeBox"></div>
          <iframe
            class="iframe hide"
            id="singleBox"
            marginwidth="0"
            marginheight="0"
            :srcdoc="srcdoc"
          ></iframe>
        </div>

        <!-- 批量打印二维码 -->
        <div class="batchPrint" v-else-if="dialogData.type === 'batchPrint'">
          <!-- <template v-if="selectIdList.length === 0">
              <p class="text">请输入需要打印二维码的设备ID区间</p>
              <div class="section">
                <span class="label">设备ID区间：</span>
                <el-input class="input" v-model="dId_b"></el-input>
                <span class="fh">~</span>
                <el-input class="input" v-model="dId_e"></el-input>
              </div>
            </template> -->
          <template>
            <p class="text">已勾选{{ selectIdList.length }}项</p>
            <p class="text">
              确认打印所选<span class="bold">{{
                activeTab === "noStorage"
                  ? "未入库"
                  : activeTab === "hasStorage"
                  ? "已入库"
                  : "已出库"
              }}</span
              >设备二维码？
            </p>
          </template>
          <div class="hide">
            <div id="batchQrcodeBox">
              <div
                class="item"
                v-for="(item, index) in selectIdList"
                :key="index"
              >
                <div class="qrcodeBoxItem" ref="qrcodeBoxItem"></div>
                <div class="itemLabel">设备ID：{{ item }}</div>
              </div>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogData.visible = false">取 消</el-button>
            <el-button type="primary" v-print="'#batchQrcodeBox'"
              >确 定</el-button
            >
          </div>
        </div>

        <!-- 已出库按钮操作 -->
        <!-- 已出库详情 -->
        <div
          class="hasOutputDetail"
          v-else-if="dialogData.type === 'hasOutputDetail'"
        >
          <div class="form">
            <p class="iTit">基本信息</p>
            <div class="inputBox">
              <span class="tit">设备ID：</span>
              {{ dialogData.info.device_no_id }}
            </div>
            <div class="inputBox">
              <span class="tit" style="margin-left:10px; width:120px;">其他平台设备id：</span>
              {{ dialogData.info.card_no }}
            </div>
            <div class="inputBox">
              <span class="tit">局域网ip：</span>
              {{ dialogData.info.board_ip }}
            </div>
            <div class="inputBox">
              <span class="tit">设备类型：</span>
              {{ dialogData.info.device_name }}
            </div>
            <div class="inputBox">
              <span class="tit">服务器组：</span>
              {{ dialogData.info.server_category_name }}
            </div>
            <div class="inputBox">
              <span class="tit">代理商名称：</span>
              {{ dialogData.info.company_name }}
            </div>
            
            <div class="inputBox">
              <span class="tit">连接类型：</span>
              {{ dialogData.info.server_type_name }}
            </div>
            <div class="inputBox w100">
              <span class="tit">固件版本：</span>
              {{
                dialogData.info.firmware_version === ""
                  ? "/"
                  : dialogData.info.firmware_version
              }}
            </div>
            <div class="inputBox w100">
              <span class="tit">备注：</span>
              {{
                dialogData.info.contents === "" ? "/" : dialogData.info.contents
              }}
            </div>
            <p class="iTit">主板信息</p>
            <div class="inputBox">
              <span class="tit">主板类型：</span>
              {{ boardTypeList[dialogData.info.board_type] }}
            </div>
            <div class="inputBox">
              <span class="tit">mac地址：</span>
              {{ dialogData.info.mac_address }}
            </div>
            <p class="iTit">时间周期</p>
            <div class="inputBox">
              <span class="tit">添加时间：</span>
              {{ dialogData.info.create_time }}
            </div>
            <div class="inputBox">
              <span class="tit">入库时间：</span>
              {{ dialogData.info.in_stock_time }}
            </div>
            <div class="inputBox">
              <span class="tit">出库时间：</span>
              {{ dialogData.info.out_stock_time }}
            </div>
            <div class="inputBox">
              <span class="tit">激活时间：</span>
              {{ dialogData.info.activation_time }}
            </div>
          </div>
        </div>

        <!-- 配置通讯地址 -->
        <div v-else-if="dialogData.type === 'configCom'">
          <el-form label-width="120px" :model="dialogData.info">
            <el-form-item label="中转方式:">
              <div class="inputBox">
                <el-select
                  class="inputDeposit"
                  v-model="dialogData.info.server_type"
                >
                  <el-option label="请选择通讯方式" value="0"></el-option>
                  <el-option label="mqtt" value="1"></el-option>
                  <el-option label="中转" value="2"></el-option>
                  <el-option label="4.0s" value="3"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="中转地址:">
              <div class="inputBox">
                <el-input
                  class="inputDeposit"
                  v-model="dialogData.info.server_address"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="configCom()">确 认</el-button>
            <el-button @click="dialogData.visible = false">取消</el-button>
          </div>
        </div>

        <!-- 修改已出库设备信息 -->
        <div
          class="editOutputDetail"
          v-else-if="
            dialogData.type === 'editOutputDetail' ||
              dialogData.type === 'hasOutputBatchEdit'
          "
        >
          <el-form
            ref="editOutputDetail"
            :rules="editOutputDetailRules"
            label-width="140px"
            :model="dialogData.info"
          >
            <el-form-item label="连接方式：" prop="server_type">
              <el-select
                class="inputDeposit"
                placeholder="请选择连接方式"
                v-model="dialogData.info.server_type"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in serverTypeList"
                  :key="index"
                  :label="item"
                  :value="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务器地址：">
              <div class="inputBox">
                <el-input
                  class="inputDeposit"
                  v-model="dialogData.info.server_address"
                  placeholder="请填写服务器地址"
                  clearable
                ></el-input>
              </div>
            </el-form-item>
            <!-- <el-form-item label="地址类型：" prop="app_config_type">
                <el-select
                  class="inputDeposit"
                  placeholder="请选择地址类型"
                  v-model="dialogData.info.app_config_type"
                  filterable
                  clearable
                  @focus="getAppConfig">
                  <el-option
                    v-for="item in appConfigList"
                    :key="item.index"
                    :label="item.name"
                    :value="item.index">
                  </el-option>
                </el-select>
              </el-form-item> -->
            <el-form-item label="地址名称：" prop="server_env_id">
              <el-select
                class="inputDeposit"
                placeholder="请选择地址名称"
                v-model="dialogData.info.server_env_id"
                @change="getActiveServerEnv"
                filterable
                clearable
              >
                <el-option
                  v-for="item in appConfigTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                  <!-- {{dialogData.info.server_env_id}}---{{item.id}} -->
                </el-option>
              </el-select>
              <el-popover
                placement="right-end"
                width="auto"
                trigger="hover"
                v-if="dialogData.info.server_env_id !== ''"
              >
                <div class="appInfoBox">
                  <div class="row">
                    <span class="label">通讯地址：</span>
                    <span class="value">{{
                      server_env.mqtt_host === "" ? "/" : server_env.mqtt_host
                    }}</span>
                  </div>
                  <div class="row">
                    <span class="label">4.0业务地址：</span>
                    <span class="value">{{
                      server_env.api_host_v4 === ""
                        ? "/"
                        : server_env.api_host_v4
                    }}</span>
                  </div>
                  <div class="row">
                    <span class="label">wms业务地址：</span>
                    <span class="value">{{
                      server_env.api_host_wms === ""
                        ? "/"
                        : server_env.api_host_wms
                    }}</span>
                  </div>
                  <div class="row">
                    <span class="label">4.0s业务地址：</span>
                    <span class="value">{{
                      server_env.api_host_v4s === ""
                        ? "/"
                        : server_env.api_host_v4s
                    }}</span>
                  </div>
                </div>
                <i class="el-icon-info" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <template v-if="dialogData.type === 'editOutputDetail'">
              <el-form-item label="通讯方式：" prop="com_type">
                <el-select
                  class="inputDeposit"
                  placeholder="请选择通讯方式"
                  v-model="dialogData.info.com_type"
                  @change="comTypeChange"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="(item, index) in comTypeList"
                    :key="index"
                    :label="item"
                    :value="index"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="其他平台设备id："
                prop="card_no"
              >
                <div class="inputBox">
                  <el-input
                    class="inputDeposit"
                    v-model="dialogData.info.card_no"
                    placeholder="请填写其他平台设备id"
                    clearable
                  ></el-input>
                </div>
              </el-form-item>

              <el-form-item label="备注：">
                <div class="inputBox">
                  <el-input
                    type="textarea"
                    v-model="dialogData.info.contents"
                    :rows="4"
                    placeholder="请填写备注"
                    clearable
                  ></el-input>
                </div>
              </el-form-item>
            </template>
            <el-form-item>
              <el-button type="primary" @click="updateOutStock"
                >确 认</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "../../../Layout/BreadCrumb.vue";
import {
  updataBreadCrumb,
  showToast,
  storage,
  deepCopy,
  isAllEqual
} from "../../../../../static/js/utility/utility.js";
import { getNowDate } from "../../../../../static/js/utility/date.js";
import {
  deviceApi,
  systemApi,
  maintainApi,
  commonApi
} from "../../../../../static/js/api.js";
import QRCode from "qrcodejs2";
import store from "../../../../store";
let vm;

export default {
  name: "ProductList",
  components: {
    BreadCrumb
  },

  data() {
    return {
      // 二维码打印
      srcdoc: "",
      // 二维码打印样式
      codeBoxStyle:
        "margin:0; width:100%; height:100vh; text-align:center; display:flex; flex-direction:column; align-items:center; justify-content:center;page-break-after:avoid;",
      codeBoxTextStyle: "font-size:30px; font-weight:bold;",
      selectIdList: [], // 批量设备id列表
      dId_b: "", //设备id开始值
      dId_e: "", //设备id结束值

      tab: {},

      // 当前显示tab
      activeTab: "noStorage",
      // 对话框数据
      dialogData: {
        type: "",
        title: "",
        visible: false,
        info: {}
      },

      pageSizes: [20, 50, 100, 200, 500],
      // 未入库数据
      noStorageData: {
        device_id: "",
        contents: "",
        selection: [],
        sourceIsDevice: false,
        paging: {
          page: 1,
          perPage: 10,
          start: "",
          end: ""
        },

        // 时间范围
        dateRange: [],
        list: [],
        loading: false
      },

      // 已入库数据
      hasStorageData: {
        selection: [],
        selectionDId: [], // 判断是否是相同的产品（批量出库使用）
        hasThirdPro: false, // 是否选择了第三方产品
        paging: {
          page: 1,
          perPage: 10,
          device_no_id: "",
          total: 0,
        },

        list: [],
        loading: false
      },

      // 已出库数据
      hasOutputData: {
        selection: [],
        hasThirdPro: false, // 是否选择了第三方产品
        paging: {
          page: 1,
          perPage: 10,
          device_no_id: "",
          company_name: "",
          device_id: "",
          online_status: "",
          sort_by: "",
          sort_order: "",
        },

        list: [],
        loading: false,
        total: 0
      },

      // 已出库设备-修改/批量修改数据
      comTypeList: {
        // 设备参数-通讯方式列表
        "1": "有线",
        "2": "4g",
        "3": "wifi",
        "4": "nb卡"
      },

      appConfigList: [], // 地址参数设置-地址列表
      appConfigTypeList: [], // 地址参数设置-地址类型列表
      server_env: {},

      serverTypeList: {
        // 地址参数设置-连接地址列表： 0未设置 1mqtt 2中转 3、4.0S
        "1": "mqtt",
        "2": "中转",
        "3": "4.0s"
      },

      editOutputDetailRules: {
        device_id: [
          { required: true, message: "请选择设备类型", trigger: "change" }
        ],
        com_type: [
          { required: true, message: "请选择通讯地址", trigger: "change" }
        ],
        // card_no: [{ required: true, message: "请输入卡号", trigger: "blur" }],
        server_env_id: [
          { required: true, message: "请选择地址名称", trigger: "change" }
        ],
        server_type: [
          { required: true, message: "请选择连接地址", trigger: "change" }
        ],
        server_category_id: [
          { required: true, message: "请选择服务组", trigger: "change" }
        ]
        // company_id: [
        //   { required: true, message: '请选择服务商名称', trigger: 'change' }
        // ],
      },

      deviceList: [],

      boardTypeList: {
        // 主板类型列表
        "0": "/",
        "1": "新唐版",
        "2": "STM32",
        "3": "外购设备"
      },

      sourceList: {
        // 来源列表
        "0": "/",
        "1": "后台添加",
        "2": "设备上报",
        "3": "第三方"
      },

      onlineStatusOption: [
        {
          value: "true",
          label: "在线"
        },
        {
          value: "false",
          label: "离线"
        }
      ]
    };
  },

  created() {
    vm = this;
    // vm.getActionRole()
    vm.getDeviceNoList();
    vm.getDeviceList();
    vm.activeTab =
      vm.$store.state.outputSuccessShowTab === ""
        ? "noStorage"
        : vm.$store.state.outputSuccessShowTab;
  },

  mounted() {},

  methods: {
    // 操作客户信息（添加或修改）dialogData
    operateDialogInfo: function(type, info) {
      // console.log('type', type)
      if (!info) {
        info = {};
      }

      // 未入库区域
      // 批量删除未入库信息
      if (type === "batchDelete" && this.noStorageData.selection.length === 0) {
        showToast("请选择要批量删除的设备！");
        return;
      }
      // 批量入库
      if (type === "batchStorage") {
        if (this.noStorageData.selection.length === 0) {
          showToast("请选择要批量入库的设备！");
          return;
        } else {
          if (this.noStorageData.sourceIsDevice) {
            showToast('"设备上报"来源的设备不支持批量入库');
            return;
          }
        }
      }
      // 未入库时，已使用的设备禁止入库和删除操作
      if ((type === "delete" || type === "storage") && info.status === "1") {
        // showToast()
        return;
      }
      // 入库信息
      let storageInfo = {
        device_no_id:
          type === "storage"
            ? [info.device_no_id]
            : this.noStorageData.selection,
        board_type: "",
        firmware_version: "",
        mac_address: ""
      };
      // 生成id信息
      let generateIdInfo = {
        number: "",
        length: "",
        contents: ""
      };
      // 手动生成id信息
      let customGenerateIdInfo = {
        device_no_id: "",
        contents: ""
      };

      // 已入库区域
      // 已入库 - 批量回收
      if (type === "batchRecycle") {
        if (this.hasStorageData.selection.length === 0) {
          showToast("请选择要批量回收的设备！");
          return;
        } else if (this.hasStorageData.hasThirdPro) {
          showToast("第三方设备禁止回收！");
          return;
        }
      }
      // 已入库 - 回收信息
      let hasStorageRecycleInfo = {
        device_no_id:
          type === "recycle"
            ? [info.device_no_id]
            : this.hasStorageData.selection
      };

      // 已出库区域
      // 已出库 - 批量回收
      if (type === "hasOutputBatchRecycle") {
        if (this.hasOutputData.selection.length === 0) {
          showToast("请选择要批量回收的设备！");
          return;
        } else if (this.hasOutputData.hasThirdPro) {
          showToast("第三方设备禁止回收！");
          return;
        }
      }
      // 已出库 - 回收信息
      let hasOutputRecycleInfo = {
        device_no_id:
          type === "hasOutputRecycle"
            ? [info.device_no_id]
            : this.hasOutputData.selection
      };
      // 已出库 - 已激活的设备禁止回收操作（is_activation：0未激活，1已激活）
      // if ( type === 'hasOutputRecycle' && info.is_activation === '1' ) {
      //   showToast('已激活的设备禁止回收')
      //   return
      // }

      // 批量打印
      if (type === "batchPrint") {
        let selectIdList = vm[vm.activeTab + "Data"].selection; // 勾选的设备
        if (selectIdList.length === 0) {
          showToast("请选择要批量打印的设备");
          return;
        }
        vm.clickBatchPrint(selectIdList);
      }
      // 已出库 - 批量修改
      let hasOutputBatchEditIInfo = {
        server_type: "",
        server_address: "",
        server_env_id: ""
      };
      if (
        type === "hasOutputBatchEdit" &&
        this.hasOutputData.selection.length === 0
      ) {
        showToast("请选择要批量修改的设备");
        return;
      }
      if (type === "editOutputDetail" || type === "hasOutputBatchEdit") {
        vm.getServerEnvList();
      }

      let title =
        type === "storage" || type === "batchStorage"
          ? "入库"
          : type === "audit"
          ? "审核"
          : type === "generateId"
          ? "生成设备ID"
          : type === "customGenerateId"
          ? "手动添加设备ID"
          : type === "hasOutputDetail"
          ? "详情"
          : type === "configCom"
          ? "配置通讯地址"
          : type === "viewQrcode"
          ? "查看二维码"
          : type === "editOutputDetail"
          ? "修改"
          : type === "hasOutputBatchEdit"
          ? "批量修改"
          : "";
      this.dialogData = {
        type: type,
        title: title,
        visible:
          type === "editOutputDetail" || type === "hasOutputBatchEdit"
            ? false
            : true,
        isReset: false,
        info:
          type === "storage" || type === "batchStorage"
            ? storageInfo
            : type === "generateId"
            ? generateIdInfo
            : type === "recycle" || type === "batchRecycle"
            ? hasStorageRecycleInfo
            : type === "hasOutputRecycle" || type === "hasOutputBatchRecycle"
            ? hasOutputRecycleInfo
            : type === "customGenerateId"
            ? customGenerateIdInfo
            : type === "hasOutputBatchEdit"
            ? hasOutputBatchEditIInfo
            : deepCopy(info)
      };
      console.log("this", this.dialogData.info);

      if (type === "viewQrcode") {
        vm.getSingleQrcode();
      }
    },

    // 获取页面权限
    async getActionRole() {
      let data = {
        function_tab: "ProductList"
      };

      let res = await commonApi.getActionRole(data);
      if (res.meta.code === 200) {
        vm.tab = res.data.tab;
      } else {
        showToast(res.meta.message);
      }
    },

    // 获取设备列表
    getDeviceList: async function() {
      let res = await maintainApi.getDeviceList();
      if (res.meta.code === 200) {
        vm.deviceList = res.data;
      } else {
        showToast(res.meta.message);
      }
    },

    // 获取某个设备二维码
    getSingleQrcode() {
      console.log("device_no_id", vm.dialogData.info.device_no_id);
      vm.$nextTick(function() {
        let Id = "singleQrcodeBox";
        let qrcode = new QRCode(vm.$refs[Id], {
          width: 150,
          height: 150, // 高度
          text: "GKV1?did=" + vm.dialogData.info.device_no_id, // 二维码内容
          render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
          background: "#fff", // 背景色
          foreground: "#000" // 前景色
        });
      });
    },

    // 单个打印二维码
    singlePrint() {
      let Id = "singleQrcodeBox";
      let imgSrc = document
        .getElementById(Id)
        .getElementsByTagName("img")[0]
        .getAttribute("src");
      vm.srcdoc =
        '<div class="codeBox" style="' +
        vm.codeBoxStyle +
        '">' +
        '<img class="code" src="' +
        imgSrc +
        '">' +
        '<p class="text" style="' +
        vm.codeBoxTextStyle +
        '">设备ID：' +
        vm.dialogData.info.device_no_id +
        "</p></div>";
      // console.log('srcdoc', vm.srcdoc)
      setTimeout(() => {
        document.getElementById("singleBox").contentWindow.print();
      }, 100);
    },

    // 获取多个设备二维码
    getBatchQrcode(list) {
      vm.$nextTick(function() {
        list.forEach((item, i) => {
          // console.log('this.$refs.qrcodeBoxItem', this.$refs.qrcodeBoxItem)
          this.$refs.qrcodeBoxItem[i].innerHTML = "";
          new QRCode(this.$refs.qrcodeBoxItem[i], {
            text: "GKV1?did=" + item, // 二维码内容
            width: 150,
            height: 150, // 高度
            render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
            background: "#fff", // 背景色
            foreground: "#000" // 前景色
          });
          // console.log('i', i)
        });
      });
    },

    // 点击批量打印按钮
    clickBatchPrint(selectIdList) {
      // console.log('selection', vm[vm.activeTab+'Data'].selection)
      vm.selectIdList = selectIdList;
      // 勾选的设备为0，则手动输入设备区间
      if (selectIdList.length === 0) {
        showToast("请选择要批量打印的设备");
        return;
      } else {
        setTimeout(() => {
          vm.getBatchQrcode(selectIdList);
        }, 500);
      }
    },

    /* 未入库 */
    // 获取未入库列表
    getDeviceNoList: async function(query) {
      // console.log('query', query)
      let data;
      // 查询
      if (query) {
        let dateRange = vm.noStorageData.dateRange;
        data = {
          page: "1",
          perPage: vm.noStorageData.paging.perPage,
          start: dateRange != "" ? getNowDate(dateRange[0]) : "",
          end: dateRange != "" ? getNowDate(dateRange[1]) : "",
          device_no_id: vm.noStorageData.device_id,
          contents: vm.noStorageData.contents,
          status: vm.noStorageData.status == true ? "1" : "0"
        };
        // console.log('dateRange', dateRange[0])
        // if (dateRange.length === 0) {
        //   showToast('请选择查询的时间范围')
        //   return
        // }
      } else {
        data = vm.noStorageData.paging;
        data.status = vm.noStorageData.status == true ? "1" : "0";
      }
      // console.log('查询数据', data)

      vm.noStorageData.loading = true;
      let res = await deviceApi.getDeviceNoList(data);
      vm.noStorageData.loading = false;
      if (res.meta.code === 200) {
        let list = res.data.list;
        for (let i in list) {
          list[i].statusName = list[i].status === "0" ? "未使用" : "已使用";
        }
        vm.noStorageData.list = [...list];
        vm.noStorageData.pageCount = res.data.pageCount;
        vm.noStorageData.total = res.data.count;
      } else {
        showToast(res.meta.message);
      }
    },

    // 删除id
    deleteId: async function() {
      let data = {
        device_no_id:
          vm.dialogData.type === "delete"
            ? [vm.dialogData.info.device_no_id]
            : vm.noStorageData.selection
      };
      // console.log('删除id数据', data)
      // return

      let res = await deviceApi.deleteId(data);
      if (res.meta.code === 200) {
        showToast((vm.dialogData.type === "delete" ? "" : "批量") + "删除成功");
        vm.dialogData.visible = !vm.dialogData.visible;
        vm.getDeviceNoList();
      } else {
        showToast(res.meta.message);
      }
    },

    // 生成id
    generateId: async function() {
      let data = vm.dialogData.info;
      // console.log('生成id数据', data)

      let res = await deviceApi.generateId(data);
      if (res.meta.code === 200) {
        showToast("设备id生成成功");
        vm.dialogData.visible = !vm.dialogData.visible;
        vm.getDeviceNoList();
      } else {
        showToast(res.meta.message);
      }
    },

    // 手动添加设备id
    customGenerateId: async function() {
      let data = vm.dialogData.info;
      // console.log('手动添加id数据', data)
      if (data.device_no_id == "") {
        showToast("设备ID不能为空！");
        return;
      }

      let res = await deviceApi.customGenerateId(data);
      if (res.meta.code === 200) {
        showToast("设备id添加成功");
        vm.dialogData.visible = !vm.dialogData.visible;
        vm.getDeviceNoList();
      } else {
        showToast(res.meta.message);
      }
    },

    // 设备id入库/批量入库
    inStock() {
      vm.$refs["storageForm"].validate(async valid => {
        if (valid) {
          let data = {
            device_no_id: vm.dialogData.info.device_no_id,
            board_type: vm.dialogData.info.board_type,
            firmware_version: vm.dialogData.info.firmware_version,
            mac_address: vm.dialogData.info.mac_address
          };
          // console.log('data', data)

          let res = await deviceApi.inStock(data);
          if (res.meta.code === 200) {
            showToast(
              (vm.dialogData.type === "storage" ? "" : "批量") + "入库成功"
            );
            vm.dialogData.visible = !vm.dialogData.visible;
            vm.getDeviceNoList();
          } else {
            showToast(res.meta.message);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 设备审核入库
    async verifyInStock() {
      let data = {
        device_no_id: vm.dialogData.info.device_no_id
      };

      let res = await deviceApi.verifyInStock(data);
      if (res.meta.code === 200) {
        showToast("审核通过，入库成功");
        vm.dialogData.visible = !vm.dialogData.visible;
        vm.getDeviceNoList();
      }
    },

    // 翻页 --- 未入库列表当前页值改变，获取新的未入库列表
    noStoragePageChange(val) {
      // console.log(`当前页: ${val}`);
      this.getDeviceNoList();
    },

    //未入库选择每页显示条数
    handleSizeChange(val) {
      this.getDeviceNoList();
    },

    // checkBox ---监听用户是否选中未入库列表
    noStorageSelectionChange(val) {
      this.noStorageData.selection = [];
      this.noStorageData.sourceIsDevice = false;
      for (let i in val) {
        this.noStorageData.selection.push(val[i].device_no_id);
        if (val[i].source === "2") {
          this.noStorageData.sourceIsDevice = true;
        }
      }
      // console.log('this.noStorageData.selection', this.noStorageData.selection)
    },

    /* 已入库 */
    // 获取已入库列表
    getInStockList: async function(query) {
      let data = vm.hasStorageData.paging;
      if (query) {
        data.page = 1;
        if (data.device_no_id === "") {
          showToast("请输入要查询的设备ID！");
          return;
        }
      }

      vm.hasStorageData.loading = true;
      let res = await deviceApi.getInStockList(data);
      vm.hasStorageData.loading = false;
      if (res.meta.code === 200) {
        let list = res.data.list;
        // 获取主板类型和通讯方式
        for (let i in list) {
          // 1 STM32 2 新唐版
          list[i].board_type_name = vm.boardTypeList[list[i].board_type];
        }
        vm.hasStorageData.list = [...list];
        vm.hasStorageData.pageCount = res.data.pageCount;
        vm.hasStorageData.paging.total = res.data.count;
        vm.hasStorageData.paging.perPage = res.data.perPage;
        vm.hasStorageData.paging.page = res.data.page;
        vm.hasStorageData.paging.pageCount = res.data.pageCount;
      } else {
        showToast(res.meta.message);
      }
    },

    // 已入库设备-回收/批量回收
    inStockRecycle: async function() {
      let data = vm.dialogData.info;

      let res = await deviceApi.inStockRecycle(data);
      if (res.meta.code === 200) {
        showToast(
          (vm.dialogData.type === "recycle" ? "" : "批量") + "回收成功"
        );
        vm.dialogData.visible = !vm.dialogData.visible;
        vm.getInStockList();
      } else {
        showToast(res.meta.message);
      }
    },

    // 已入库设备-出库/批量出库
    output: function(type, aInfo) {
      // console.log('单个设备信息aInfo', aInfo)
      // 批量出库
      if (type === "batchOutput") {
        if (this.hasStorageData.selection.length === 0) {
          showToast("请选择要批量出库的设备！");
          return;
        } else {
          let selectionDId = isAllEqual(this.hasStorageData.selectionDId);
          console.log("selectionDId", selectionDId);
          if (!isAllEqual(this.hasStorageData.selectionDId)) {
            showToast("不同设备类型暂不支持批量出库");
            return;
          }
        }
      }
      let device_no_id =
        type === "output"
          ? [aInfo.device_no_id]
          : this.hasStorageData.selection;
      let device_id =
        type === "output"
          ? aInfo.device_id
          : this.hasStorageData.selectionDId[0];
      let navBarActive = [{ function_tab: "Output", function_name: "出库" }];
      // 更新面包屑内容（第三级）
      updataBreadCrumb(3, navBarActive);
      this.$router.push({
        path: "/Output",
        query: { device_no_id, device_id }
      });
    },

    // 翻页 --- 已入库列表每页显示数据改变，获取新的已入库列表
    hasStorageSizeChange() {
      this.getInStockList();
    },

    // 翻页 --- 已入库列表当前页值改变，获取新的已入库列表
    hasStoragePageChange(val) {
      // console.log(`当前页: ${val}`);
      this.getInStockList();
    },

    // checkBox ---监听用户是否选中未入库列表
    hasStorageSelectionChange(val) {
      this.hasStorageData.selection = [];
      this.hasStorageData.selectionDId = [];
      this.hasStorageData.hasThirdPro = false;
      val.forEach((item, i) => {
        this.hasStorageData.selection.push(item.device_no_id);
        this.hasStorageData.selectionDId.push(item.device_id);
        if (item.device_id !== "0") {
          this.hasStorageData.hasThirdPro = true;
        }
      });
      // console.log('this.hasStorageData.selection', this.hasStorageData.selection)
    },

    /* 已出库 */
    // 获取已出库列表
    getOutStockList: async function(query) {
      let data = vm.hasOutputData.paging;
      if (query) {
        data.page = 1;
        // if (data.device_no_id === '') {
        //   showToast('请输入要查询的设备ID！')
        //   return
        // }
      }

      vm.hasOutputData.loading = true;
      let res = await deviceApi.getOutStockList(data);
      vm.hasOutputData.loading = false;
      if (res.meta.code === 200) {
        let list = res.data.list;
        // 获取主板类型和通讯方式
        for (let i in list) {
          list[i].online_name = list[i].online ? "在线" : "离线";
          list[i].is_activation_text =
            list[i].is_activation === "0" ? "未激活" : "已激活";
        }
        vm.hasOutputData.list = [...list];
        vm.hasOutputData.pageCount = res.data.pageCount;
        vm.hasOutputData.total = parseInt(res.data.count);
      } else {
        showToast(res.meta.message);
      }
    },

    // 已出库设备 - 回收/批量回收
    outStockRecycle: async function() {
      let data = vm.dialogData.info;

      let res = await deviceApi.outStockRecycle(data);
      if (res.meta.code === 200) {
        showToast(
          (vm.dialogData.type === "hasOutputRecycle" ? "" : "批量") + "回收成功"
        );
        vm.dialogData.visible = !vm.dialogData.visible;
        vm.getOutStockList();
      } else {
        showToast(res.meta.message);
      }
    },

    // 已出库设备 - 配置主板
    configMainboard: function(deviceInfo) {
      // 已入库 - 设备状态为*离线*禁止配置主板和回收操作
      if (!deviceInfo.online) {
        return;
      }

      // 本地会话存储设备数据，用于配置主板页面
      storage.sessionSetItem("deviceInfo", deviceInfo);
      let navBarActive = [
        { function_tab: "ConfigMainboard", function_name: "配置主板" }
      ];
      // 更新面包屑内容（第三级）
      updataBreadCrumb(3, navBarActive);
      this.$router.push({
        path: "/ConfigMainboard"
        // query: {deviceInfo: JSON.stringify(deviceInfo)}
      });
    },

    // 已出库设备 - 配置通讯
    configCom: async function() {
      let data = {
        device_no_id: vm.dialogData.info.device_no_id,
        server_type: vm.dialogData.info.server_type,
        server_address: vm.dialogData.info.server_address
      };

      let res = await deviceApi.configCom(data);

      if (res.meta.code === 200) {
        showToast("配置成功");
        vm.dialogData.visible = false;
        vm.getOutStockList();
      } else {
        showToast(res.meta.message);
      }
    },

    // 已出库设备-进入箱格配置信息
    boxConfig(row) {
      let device_no_id = row.device_no_id;
      let navBarActive = [
        { function_tab: "BoxConfig", function_name: "配置信息" }
      ];
      // 更新面包屑内容（第三级）
      updataBreadCrumb(3, navBarActive);
      this.$router.push({
        path: "/BoxConfig",
        query: { device_no_id: device_no_id }
      });
    },

    // 已出库设备-获取地址参数列表
    async getServerEnvList() {
      let res = await systemApi.getServerEnvList();
      if (res.meta.code === 200) {
        vm.appConfigTypeList = res.data;
        vm.dialogData.visible = true;
        vm.getActiveServerEnv();
      } else {
        showToast(res.meta.message);
      }
    },

    // 获取当前选中的地址名称信息
    getActiveServerEnv() {
      let id = vm.dialogData.info.server_env_id;
      if (id === "" || id === undefined) {
        return;
      }
      vm.appConfigTypeList.forEach((item, i) => {
        if (item.id === id) {
          vm.server_env = item;
        }
      });
    },

    // 通讯方式值发生改变,清空卡号
    comTypeChange(val) {
      vm.dialogData.info.card_no = "";
    },

    // 修改已出库设备信息（单个修改/批量修改）
    updateOutStock() {
      vm.$refs["editOutputDetail"].validate(async valid => {
        if (valid) {
          let { type, info } = vm.dialogData;
          let data = {
            device_no_id:
              type === "editOutputDetail"
                ? [info.device_no_id]
                : vm.hasOutputData.selection,
            server_type: info.server_type,
            server_address: info.server_address,
            server_env_id: info.server_env_id
          };
          if (type === "editOutputDetail") {
            data.com_type = info.com_type;
            (data.card_no = info.card_no), (data.contents = info.contents);
          }

          let res = await deviceApi.updateOutStock(data);
          if (res.meta.code === 200) {
            showToast("修改成功");
            vm.dialogData.visible = false;
            vm.getOutStockList();
          } else {
            showToast(res.meta.message);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 每页显示条数变化 --- 已出库列表当前页值改变，获取新的已出库列表
    hasOutputSizeChange() {
      // console.log('hasOutputData', this.hasOutputData.paging)
      this.getOutStockList();
    },

    // 翻页 --- 已出库列表当前页值改变，获取新的已出库列表
    hasOutputPageChange(val) {
      // console.log(`当前页: ${val}`);
      this.getOutStockList();
    },

    // checkBox ---监听用户是否选中已出库列表
    hasOutputSelectionChange(val) {
      this.hasOutputData.selection = [];
      this.hasOutputData.hasThirdPro = false;
      val.forEach((item, i) => {
        this.hasOutputData.selection.push(item.device_no_id);
        if (item.source === "3") {
          this.hasOutputData.hasThirdPro = true;
        }
      });
      // console.log('this.hasOutputData.selection', this.hasOutputData.selection)
    },

    // 公共方法
    // 禁选
    unChecked: function(row, index) {
      // console.log('row', row)
      // console.log('index', index)
      // if (row.firmware_version) {
      //   // 有固件版本就是已出库列表 - 已出库列表设备为离线状态，不能配置主板和回收
      //   if (!row.online) {
      //     return 0
      //   }else{
      //     return 1
      //   }
      // } else {
      //   // 未入库列表 - 未入库列表设备状态为已使用，不能删除或者入库；
      //   if (row.status === '1') {
      //     return 0
      //   }else{
      //     return 1
      //   }
      // }
    },

    // 查看日志
    viewLog: function() {
      let navBarActive = [
        { function_tab: "ViewLog", function_name: "查看日志" }
      ];
      // 更新面包屑内容（第三级）
      updataBreadCrumb(3, navBarActive);
      // 出库成功后，返回生产列表显示tab
      this.$store.state.outputSuccessShowTab = this.activeTab;
      this.$router.push({
        path: "/ViewLog"
      });
    },

    handleSortChange: function(obj) {
      let sortOrder = '';
      if (obj.order == 'ascending') {
        sortOrder = 'asc';
      } else if (obj.order == 'descending') {
        sortOrder = 'desc';
      } else if (obj.order == null) {
        sortOrder = '';
      }

      vm.hasOutputData.paging.sort_order = sortOrder;
      vm.hasOutputData.paging.sort_by = obj.prop;

      this.getOutStockList();
    },

  },

  watch: {
    // 监听当前显示tab的变化，获取新的入库列表
    activeTab: function(newval) {
      if (newval === "noStorage") {
        // tab值变化清空搜索字段
        this.noStorageData.dateRange = [];
        this.getDeviceNoList();
      } else if (newval === "hasStorage") {
        this.hasStorageData.paging.device_no_id = "";
        this.getInStockList();
      } else {
        this.hasOutputData.paging.device_no_id = "";
        this.getOutStockList();
      }
    },

    // 监听未入库查询日期的变化，为null重新获取未入库列表
    "noStorageData.dateRange": function(newVal) {
      // console.log('end', newVal)
      if (newVal === null) {
        this.getDeviceNoList();
      }
    },

    // 监听已入库查询id的变化，清空获取新的已入库列表
    "hasStorageData.paging.device_no_id": function(newVal) {
      // console.log('已入库查询id', newVal)
      if (newVal === "") {
        this.getInStockList();
      }
    },

    // 监听已出库查询id的变化，清空获取新的已出库列表
    "hasOutputData.paging.device_no_id": function(newVal) {
      // console.log('已出库查询id', newVal)
      if (newVal === "") {
        this.getOutStockList();
      }
    },

    // 已出库设备-修改-地址类型变化时
    "dialogData.info.app_config_type"(newVal) {
      // console.log('newVal', newVal)
      vm.dialogData.info.server_env_id = "";
      vm.appConfigTypeList =
        newVal === "" ? [] : vm.appConfigList[newVal].children;
    }
  }
};
</script>

<style lang="scss" scoped>
// 批量打印样式
.batchPrint {
  .text {
    margin-bottom: 10px;
  }
  .section {
    margin: 15px;
    display: flex;
    align-items: center;
    span {
      flex-shrink: 0;
    }
    .input {
      width: 200px;
    }
    .fh {
      margin: 0 20px;
    }
  }
  .bold {
    font-weight: bold;
  }
}
#batchQrcodeBox {
  .item {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .itemLabel {
      margin-top: 30px;
      font-size: 30px;
      font-weight: bold;
      color: #333333;
    }
  }
}
// 出库设备-app配置信息
.appInfoBox {
  .row {
    width: 100%;
    display: flex;
    .label {
      width: 110px;
      text-align: right;
      color: #606266;
    }
    .value {
      color: #333333;
    }
  }
}
.ProductList {
  width: 100%;
  .btnDiv {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .ml20 {
      margin-left: 20px;
    }
  }
  .queryBox {
    width: 100%;
    // .dateInput,
    // .symbol,
    // .queryBtn {
    //   float: left
    // }
    .dateInput {
      width: 250px;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    .symbol {
      font-size: 20px;
      margin-right: 20px;
      line-height: 40px;
    }
    .queryBtn {
      margin-left: 20px;
    }
  }
  .btnArea {
    margin: 20px 0;
    .batchStorageBtn,
    .batchDeleteBtn,
    .batchRecycleBtn,
    .batchOutputBtn {
      float: left;
    }
    .viewLogBtn,
    .createIdBtn {
      float: right;
    }
  }
  .el-dialog {
    .inputBox {
      .inputDeposit {
        width: 200px;
      }
    }
    .qrcodeBox {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .btnBox {
        width: 100%;
        display: flex;
        justify-content: flex-end;
      }
      #singleQrcodeBox {
        width: 190px;
        padding: 20px 20px 10px;
      }
    }
    .hasOutputDetail {
      margin-top: -20px;
      font-size: 14px;
      line-height: 30px;
      .top {
        font-weight: bold;
        span {
          margin-right: 5px;
        }
      }
      .form {
        color: #333333;
        display: flex;
        flex-wrap: wrap;
        .iTit {
          width: 100%;
          margin-top: 10px;
          font-size: 16px;
          font-weight: bold;
        }
        .inputBox {
          width: 50%;
          display: flex;
          &.w100 {
            width: 100%;
          }
          .tit {
            flex-shrink: 0;
            width: 90px;
            margin-right: 10px;
            text-align: right;
            color: #777;
            display: inline-block;
          }
        }
      }
    }
  }
  .operate .text,
  .forbid.operate .text.normal {
    color: #409eff;
  }
  .operate .text.is-disabled {
    color: #c0c4cc;
    cursor: not-allowed;
  }
  .forbid,
  .forbid.operate .text {
    color: #cccccc;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/DeviceManage/ProductList/SIndex.vue